import React from 'react';
import Rodal from 'rodal';
import 'rodal/lib/rodal.css';

const Modal: React.FC<any> = ({ children, ...props }) => {
  return <Rodal {...props}>{children}</Rodal>;
};

export default Modal;
